import React from "react";
import {
  ArrowDownIcon,
  ArrowUpIcon,
  TrashIcon,
  Bars3Icon,
} from "@heroicons/react/24/outline";

export function FormDocumentBlockWrapper({
  children,
  mode = "fill",
  selected = false,
  onSelect,
  onMoveUp,
  onMoveDown,
  onDelete,
  canMoveUp = true,
  canMoveDown = true,
  dragHandleProps = null,
  innerRef = null,
  draggableProps = null,
  isDragging = false,
}) {
  if (mode === "fill") {
    return <div className="py-2">{children}</div>;
  }

  return (
    <div
      ref={innerRef}
      {...(draggableProps || {})}
      {...(dragHandleProps || {})}
      style={draggableProps?.style}
      className={`group relative rounded-2xl border px-4 py-3 pl-8 transition ${
        isDragging
          ? "border-slate-900 bg-white shadow-lg"
          : selected
            ? "border-slate-900 bg-slate-50 shadow-sm"
            : "border-transparent hover:border-slate-200 hover:bg-white"
      }`}
      onClick={(e) => {
        e.stopPropagation();
        onSelect?.();
      }}
      role="presentation"
    >
      <div
        className="absolute left-2 top-3 flex cursor-grab items-center rounded-full p-1 active:cursor-grabbing"
        aria-hidden
      >
        <Bars3Icon className="h-4 w-4 text-slate-400" />
      </div>
      <div className="absolute -right-2 top-2 flex items-center gap-1 rounded-full border border-slate-200 bg-white p-1 shadow-sm opacity-0 transition group-hover:opacity-100">
        <button
          type="button"
          disabled={!canMoveUp}
          onClick={(e) => {
            e.stopPropagation();
            onMoveUp?.();
          }}
          className="rounded-full p-1 text-slate-500 hover:bg-slate-100 disabled:opacity-30"
        >
          <ArrowUpIcon className="h-4 w-4" />
        </button>
        <button
          type="button"
          disabled={!canMoveDown}
          onClick={(e) => {
            e.stopPropagation();
            onMoveDown?.();
          }}
          className="rounded-full p-1 text-slate-500 hover:bg-slate-100 disabled:opacity-30"
        >
          <ArrowDownIcon className="h-4 w-4" />
        </button>
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onDelete?.();
          }}
          className="rounded-full p-1 text-rose-500 hover:bg-rose-50"
        >
          <TrashIcon className="h-4 w-4" />
        </button>
      </div>
      {children}
    </div>
  );
}
